// extracted by mini-css-extract-plugin
export default {"container":"helpComp_container__858S-","title":"helpComp_title__J6Ym7","details":"helpComp_details__I8Eqf"};